// extracted by mini-css-extract-plugin
export default {"cta_button":"CTAButton_cta_button__3VQrx","large":"CTAButton_large__0RxpP","short":"CTAButton_short__ZiqpZ"};